import ClienteEnderecoEntregaModel from "../models/clienteEnderecoEntregaModel";
import ClienteModel from "../models/clienteModel";
import nfetch from "../utils/events/nfetch";

import { IService } from "./base/iService";

export default class ClienteService extends IService<ClienteModel> {
    constructor() {
        super("Cliente");
    }

    public listByFranquiaId(franquiaId: number) {
        return nfetch(`/${this.controllerName}/ListByFranquiaId?franquiaId=${franquiaId}`, {
            credentials: "same-origin",
        });
    }

    public insertUpdateEnderecoEntrega(model: ClienteEnderecoEntregaModel): Promise<Response> {
        return nfetch(`/${this.controllerName}/InsertUpdateEnderecoEntrega`, {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "XSRF-TOKEN": this.getCookie("XSRF-TOKEN"),
            },
            body: JSON.stringify(model),
        });
    }

    public listCliente(
        filterKey: string,
        sortKey: string,
        sortOrder: string,
        pageIndex: number,
        pageSize: number,
        emissaoDe = "",
        emissaoAte = "",
    ): Promise<Response> {
        const encodedFilter = encodeURIComponent(filterKey);
        return nfetch(
            `/${this.controllerName}/ListCliente?filterKey=${encodedFilter}&sortKey=${sortKey}&sortOrder=${sortOrder}&pageIndex=${pageIndex}&pageSize=${pageSize}&emissaoDe=${emissaoDe}&emissaoAte=${emissaoAte}`,
            {
                credentials: "same-origin",
                method: "get",
            },
        );
    }

    public getClientesDuplicados(filterKey: string, pageIndex: number, pageSize: number): Promise<Response> {
        const encodedFilter = encodeURIComponent(filterKey);

        return nfetch(
            `/${this.controllerName}/GetClientesDuplicados?filterKey=${encodedFilter}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
            {
                credentials: "same-origin",
            },
        );
    }

    public getCamposDescricao(): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetCampos`, {
            credentials: "same-origin",
        });
    }

    public getClientesDuplicadosByCliente(model: ClienteModel): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetClientesDuplicadosByCliente`, {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "XSRF-TOKEN": this.getCookie("XSRF-TOKEN"),
            },
            body: JSON.stringify(model),
        });
    }

    public unificarClientes(clienteIdOrigem: number, clienteIdDestino: number): Promise<Response> {
        return nfetch(
            `/${this.controllerName}/UnificarClientes?clienteIdOrigem=${clienteIdOrigem}&clienteIdDestino=${clienteIdDestino}`,
            {
                method: "post",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    "XSRF-TOKEN": this.getCookie("XSRF-TOKEN"),
                },
            },
        );
    }

    public existsByCPF(cpf: string): Promise<Response> {
        return nfetch(`/${this.controllerName}/ExistsByCPF?cpf=${cpf}`, {
            credentials: "same-origin",
            method: "get",
        });
    }

    public getByCPF(cpf: string): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetByCPF?cpf=${cpf}`, {
            credentials: "same-origin",
            method: "get",
        });
    }

    public existsByCNPJ(cnpj: string): Promise<Response> {
        return nfetch(`/${this.controllerName}/ExistsByCNPJ?cnpj=${cnpj}`, {
            credentials: "same-origin",
            method: "get",
        });
    }

    public getNotificacoesByClienteId(clienteId: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetNotificacoesByClienteId?clienteId=${clienteId}`, {
            credentials: "same-origin",
            method: "get",
        });
    }

    public getFromSearchComboById(id: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetFromSearchComboById?id=${id}`, {
            credentials: "same-origin",
        });
    }

    public getFromSearchComboByText(filterKey = "", franquiaId: number | null = 0): Promise<Response> {
        return nfetch(
            `/${this.controllerName}/GetFromSearchComboByText?filterKey=${filterKey}&franquiaId=${franquiaId || 0}`,
            {
                credentials: "same-origin",
            },
        );
    }

    public getByIdFromVenda(id: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetByIdFromVenda?id=${id}`, {
            credentials: "same-origin",
            method: "get",
        });
    }

    public replicarCliente(idCliente: number, idFranquias: number[]): Promise<Response> {
        return nfetch(`/${this.controllerName}/ReplicarCliente?idCliente=${idCliente}`, {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify(idFranquias),
        });
    }
}
